import { render, staticRenderFns } from "./judicial-guard-type.vue?vue&type=template&id=778e101a&"
import script from "./judicial-guard-type.vue?vue&type=script&lang=js&"
export * from "./judicial-guard-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports